import { useState } from 'react';
import Modal from './ui/Modal';
import { site } from '../data/content';
import { legalDocs } from '../data/legal';

function LegalBlock({ block }) {
  if (block.t === 'h') return <h3>{block.x}</h3>;
  if (block.t === 'ul') {
    return (
      <ul>
        {block.items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  }
  return <p>{block.x}</p>;
}

export default function Footer() {
  const [openId, setOpenId] = useState(null);
  const openDoc = legalDocs.find((doc) => doc.id === openId);

  return (
    <footer>
      <div className="wrap">
        <span>© {site.brand} 2026. All rights reserved.</span>

        <nav className="footer-legal">
          {legalDocs.map((doc) => (
            <button key={doc.id} type="button" onClick={() => setOpenId(doc.id)}>
              {doc.label}
            </button>
          ))}
        </nav>
      </div>

      <Modal open={Boolean(openDoc)} title={openDoc?.label} onClose={() => setOpenId(null)}>
        {openDoc?.blocks.map((block, i) => (
          <LegalBlock key={i} block={block} />
        ))}
      </Modal>
    </footer>
  );
}
